import React, { useMemo } from 'react'
import { HeaderWapper, Heading, TableContainer, TableWapper, Wapper } from '../style'
import { strings } from '@constants'
import { showDateFormat } from '@utils'
import { useNavigate } from 'react-router'
import { paths } from '@routes'

const BlacklistedOrg = ({ data }) => {
	const navigate = useNavigate()
	const columns = useMemo(() => {
		return [
			{
				label: strings('blacklisted_at'),
				key: 'blacklisted_at',
				renderer: (data) => showDateFormat(new Date(data)),
				mobile: true,
			},
			{
				label: strings('blacklisted_by'),
				key: 'blacklisted_by',
				mobile: true,
			},
			{
				label: strings('organisation_id'),
				key: 'organisation_id',
				mobile: true,
			},
			{
				label: strings('organisation', 'name'),
				key: 'organisation_name',
				mobile: true,
			},
			{
				label: strings('reason'),
				key: 'reason',
				renderer: (data) => data ?? '--',
				mobile: true,
			},
		]
	}, [])

	const rowClickHandler = (row) => {
		navigate(paths.admin_organisations_details_org(row?.organisation_id))
	}

	return (
		<Wapper FlexColumn>
			<HeaderWapper>
				<Heading>Blacklisted Suppliers</Heading>
			</HeaderWapper>
			<TableContainer>
				<TableWapper
					fullHeight={true}
					data={data || []}
					columns={columns}
					rowsToDisplay={data?.length}
					totalItemCount={data?.length}
					page={0}
					onRowClick={rowClickHandler}
					rowClickable={true}
					hideFooter
				/>
			</TableContainer>
		</Wapper>
	)
}

export default BlacklistedOrg
